import { FAVORITE_STORAGE_KEY } from '@/constants/auth'

function readList() {
  try {
    const raw = localStorage.getItem(FAVORITE_STORAGE_KEY)
    return raw ? JSON.parse(raw) : []
  } catch (error) {
    return []
  }
}

function writeList(list) {
  localStorage.setItem(FAVORITE_STORAGE_KEY, JSON.stringify(list))
}

export function isFavorite(regNo) {
  if (!regNo) return false
  return readList().includes(String(regNo))
}

export function toggleFavorite(regNo) {
  if (!regNo) {
    return { favorited: false, list: readList() }
  }

  const key = String(regNo)
  const list = readList()
  const index = list.indexOf(key)

  if (index === -1) {
    list.push(key)
    writeList(list)
    return { favorited: true, list }
  }

  list.splice(index, 1)
  writeList(list)
  return { favorited: false, list }
}
